module.exports = __webpack_public_path__ + "media/src/components/HomePage/HowItWorks/number-3-525bc2acb37eddc9539637e42d3fec84.png";